import { DocumentationArticle } from '../components/DocumentationArticle';

export const FindHelp = () => {
  return (
    <DocumentationArticle
      title="Where to Find Help Inside EchoRatings"
      description="This guide shows you where to find help inside EchoRatings so you can get answers quickly without leaving the app."
      timeToComplete="2-3 minutes"
      requirements={['Access to your EchoRatings account']}
      sections={[
        {
          title: 'Section 1: Access Helpcenter',
          content: (
            <>
              <ol className="list-decimal list-inside space-y-2 mb-4">
                <li>Log in to your EchoRatings account.</li>
                <li>Look for the help option within the app interface.</li>
                <li>Open the Helpcenter panel.</li>
              </ol>
              <p>
                This help panel is available while you work, so you can find
                answers without interrupting your setup or daily tasks.
              </p>
            </>
          ),
        },
        {
          title: 'Section 2: Browse Help Articles',
          content: (
            <>
              <p className="mb-4">
                Inside the helpcenter panel, you can browse help articles by topic.
              </p>
              <p className="mb-2">These articles cover:</p>
              <ul className="list-disc list-inside space-y-1 mb-4">
                <li>Getting started steps</li>
                <li>Connecting review platforms</li>
                <li>Automations and review activity</li>
                <li>Common questions and issues</li>
              </ul>
              <p>
                Articles are short and focused, so you can find what you need
                quickly.
              </p>
            </>
          ),
        },
        {
          title: 'Section 3: Search for Answers',
          content: (
            <>
              <p className="mb-4">If you know what you're looking for:</p>
              <ol className="list-decimal list-inside space-y-2 mb-4">
                <li>Use the search field in the Helpcenter panel.</li>
                <li>Enter a short description of your question.</li>
                <li>Select the most relevant article from the results.</li>
              </ol>
              <p>Search is the fastest way to find specific instructions.</p>
            </>
          ),
        },
        {
          title: 'Section 4: Contact Support from the App',
          content: (
            <>
              <p className="mb-4">
                If an article doesn't answer your question, you can contact support
                directly from the help panel.
              </p>
              <ol className="list-decimal list-inside space-y-2 mb-4">
                <li>Open the Helpcenter.</li>
                <li>Choose the option to contact support.</li>
                <li>Describe your question or issue.</li>
              </ol>
              <p>
                Your message will be sent with context from your account, which
                helps support respond more efficiently.
              </p>
            </>
          ),
        },
        {
          title: 'Section 5: When to Use Helpcenter',
          content: (
            <>
              <p className="mb-4">Helpcenter is useful when you:</p>
              <ol className="list-decimal list-inside space-y-2 mb-4">
                <li>Are setting up your account.</li>
                <li>Need guidance on a specific task.</li>
                <li>Want quick clarification without leaving the app.</li>
              </ol>
              <p>For most questions, this should be your first stop.</p>
            </>
          ),
        },
      ]}
      faq={[
        {
          question: 'Do I need to leave EchoRatings to get help?',
          answer: 'No. Help is available directly inside the app.',
        },
        {
          question: 'Can I search for help articles at any time?',
          answer:
            "Yes. The help panel is always available when you're logged in.",
        },
        {
          question: 'Will contacting support slow down my work?',
          answer:
            'No. You can continue using EchoRatings after submitting a support request.',
        },
      ]}
    />
  );
};
